import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import TablaBuquesAnunciados from './TablaBuquesAnunciados'
import { actualizarDatosParaMuiTable } from '../../actions/TablaBuquesAnunciadosActions'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import LinkIcon from '@material-ui/icons/Link'
import WavesIcon from '@material-ui/icons/Waves'
import { COLORES } from '../../../../config/colores'
import DialogoCalendarioCargas from '../../components/anunciobuques/DialogoCalendarioCargas'

function AnunciosBuques (props) {
  useEffect(() => {
    props.actualizarDatosParaMuiTable()
  }, [props])

  const url = 'https://puertoquequen.com/descargas/operativa/Buques_lista.pdf'
  const urlWindGuru = 'https://www.windguru.cz/8170'

  const renderButton = (url, titulo, icono, buttonColor = 'default') => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 22px' }}>
        <a href={url} target='blank' rel='' className='link-anuncio-buques'>
          <Button
            type='button'
            size='small'
            variant='contained'
            color={buttonColor}
            style={{ width: '100%' }}
          >
            {icono}
            {titulo}
          </Button>
        </a>
      </div>
    )
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <h2>Buques anunciados</h2>
      <div className='header-links-anuncio-buques'>
        <DialogoCalendarioCargas />
        {renderButton(urlWindGuru, 'Windguru', <WavesIcon style={{ color: '#ffffff', margin: '0 5' }} />, 'primary')}
        {renderButton(url, 'Situación del puerto', <LinkIcon style={{ color: COLORES.grey.dark, margin: '0 5' }} />)}
      </div>
      <TablaBuquesAnunciados style={{ margin: '0' }} />
    </>
  )
}
const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

export default connect(null, mapActionsToProps)(AnunciosBuques)
